import Vue from 'vue'

import Loading from '@/components/Loading.vue'

import { COLOR_WHITE } from '@/constants/colors.ts'

export default {
  functional: true,
  props: {
    loading: Boolean,
    link: Boolean,
    size: {
      type: String,
      default: '2rem',
    },
  },
  render(h, context) {
    return (
      <button
        class="btn"
        {...context.data}
        class={{
          'btn--loading': context.props.loading,
          'btn--link': context.props.link,
        }}
        disabled={context.props.loading}
      >
        <Loading
          size={context.props.size}
          color={context.props.link ? undefined : COLOR_WHITE}
          loading={context.props.loading}
        />
        {!context.props.loading ? context.children : null}
      </button>
    )
  },
}
